import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-terracotta hover:bg-terracotta-hover text-white font-bold py-4 px-8 rounded-full
        shadow-[0_4px_14px_0_rgba(196,112,75,0.39)] hover:shadow-[0_6px_20px_rgba(196,112,75,0.23)]
        transition-colors duration-200 text-lg md:text-xl tracking-wide
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-239">
      {children}
    </motion.button>;
}